import { SHOW_MODAL } from './constants';

export const showModal = (modalName, payload=undefined, replace=false) => ({
  type: SHOW_MODAL,
  modal: modalName,
  payload,
  replace
});
